import { useContext } from "react";

import appContext from "../context/appContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import ReactTooltip from "react-tooltip";
import Search from "./Search";

let searchTooltipRef;
const AreaOfInterest = () => {
    const { state } = useContext(appContext);

    if (!state.searchFeature || state.isStartScreenVisisble) return null;

    const hideTooltip = ()=>{
        searchTooltipRef.tooltipRef = null;
        ReactTooltip.hide();
    }
    return (
        <div style={{ padding: 10 }}>
            <span style={{ fontSize: "1.25em", fontWeight: 700 }}>{state.searchFeature.label}</span>
            <div className="changeLocation">
                <span data-tip={""} data-for={"renderSearchTip"}>
                    <FontAwesomeIcon icon={faUndo} style={{ marginRight: 5 }} />
                    Change location
                </span>
                <ReactTooltip
                    id="renderSearchTip"
                    effect="solid"
                    event="click"
                    clickable={true}
                    ref={(el) => (searchTooltipRef = el)}
                >
                    <>
                        <FontAwesomeIcon
                            icon={faTimesCircle}
                            onClick={hideTooltip}
                            style={{ float: "right", marginRight: -12 }}
                        />
                        <div style={{ paddingRight: 10, clear: "both", width: 500 }}>
                            <Search
                                onSelect={hideTooltip}
                            />
                        </div>
                    </>
                </ReactTooltip>
            </div>
        </div>
    );
};
export default AreaOfInterest;
